'use strict';

module.exports = class AttributeEvaluationResponse {
    constructor(key, result, evaluateState, formula, exception) {
        this._key = key;
        this._result = result || false;
        this._evaluateState = evaluateState || false;
        this._formula = formula || undefined;
        this._exception = exception || undefined;
    }

    get key() {
        return this._key;
    }

    get result() {
        return this._result;
    }

    get evaluateState() {
        return this._evaluateState;
    }

    get formula() {
        return this._formula;
    }

    get exception() {
        return this._exception;
    }
};
